module.exports = __webpack_public_path__ + "static/img/kucun.b6f313e6.png";